export const DELIMITERS = { COMMA: 'comma', SEMICOLON: 'semicolon', TAB: 'tab' } as const;

export const FILE_TYPES: string[] = ['.csv'];

export const CRITICAL_ERRORS = {
    CSV_EFFECTIVELY_EMPTY: 'E_POC_RA_0001',
    MISSING_HEADERS_LINE: 'E_POC_RA_0002',
    MISSING_TRAINING_HEADER: 'E_POC_RA_0004',
    MISSING_OPERATOR_HEADER: 'E_POC_RA_0005',
};

export const NON_CRITICAL_ERRORS = {
    EMPTY_LINE: 'E_POC_RA_0003',
    MISSING_VALUE_FOR_TRAINING_HEADER: 'E_POC_RA_0006',
    MISSING_ALL_VALUES_FOR_OPERATORS_HEADER: 'E_POC_RA_0007',
    OPERATOR_NOT_FOUND: 'E_POC_RA_0008',
    LMS_TASK_NOT_FOUND: 'E_POC_RA_0009',
    MISSING_OPERATOR_FALLBACK_HEADER: 'E_POC_RA_0011',
    MAPPING_CONTAINS_MISSING_POC_FIELD: 'E_POC_RA_0010',
};

const getErrorsTranslations = (obj: object) => Object.assign({}, ...Object.entries(obj).map(([a, b]) => ({ [b]: a })));

export const CRITICAL_ERRORS_TRANSLATIONS = getErrorsTranslations(CRITICAL_ERRORS);

export const NON_CRITICAL_ERRORS_TRANSLATIONS = getErrorsTranslations(NON_CRITICAL_ERRORS);
